import React from "react";
import { Link } from "react-router-dom";
import { Card, Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

/* PRODUCTS */

const products = [
  {
    name: "PARKEASE",
    description: "Manage vehicle entry, parking fees, and reports efficiently.",
    link: "/parking"
  },
  {
    name: "CAT HOMIS",
    description: "Hotel and room booking management system with billing.",
    link: "/cathomisLive"
  },
  {
    name: "POSPRESSO",
    description: "Restaurant and bar sales system with fast billing.",
    link: "/pospressolive"
  },
  {
    name: "POSPRESS PLUS",
    description: "Complete management for restaurant, bar, parking and washbay.",
    link: "/PospressoPlusLive"
  },
  {
    name: "TRADE HUB",
    description: "Online platform for buying and selling products.",
    link: "/tradehublive"
  }
];

function LiveDemo() {
  return (
    <div className="bg-light py-4">

      <Container fluid>

        {/* TITLE */}
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center mb-2"
        >
          <strong>FREE LIVE DEMO</strong>
        </motion.h2>

        <p className="text-center text-muted mb-4">
          Choose any of our applications and try it out instantly.
          Discover powerful features, test real functionalities,
          and see how our solutions can simplify your business—all at no cost.
        </p>

        {/* GRID */}
        <Row className="g-3">

          {products.map((product, index) => (

           <Col key={index} xl={2} lg={2} md={2} sm={6} xs={12}>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: index * 0.1 }}
              >

                <Card className="h-100 shadow-sm">

                  <Card.Body className="d-flex flex-column p-3">

                    {/* NAME */}
                    <Card.Title
                      className="text-center fw-bold"
                      style={{ fontSize: "20px" }}
                    >
                      {product.name}
                    </Card.Title>

                    {/* DESCRIPTION */}
                    <Card.Text
                      style={{ fontSize: "13px", minHeight: "60px" }}
                    >
                      {product.description}
                    </Card.Text>

                    {/* MORE DETAILS LINK */}
                    <div className="mt-auto text-center">
                      <Link
                        to={product.link}
                        className="text-decoration-none fw-bold"
                        style={{ color: "#0d6efd" }}
                      >
                       LIVE DEMO →
                      </Link>
                    </div>

                  </Card.Body>

                </Card>

              </motion.div>

            </Col>

          ))}

        </Row>

      </Container>

    </div>
  );
}

export default LiveDemo;